import React from "react"
import Slider from "react-slick"
import { Block } from "baseui/block"

type HighlightBannerProps = {
  banners: any[]
}

type Banner = {
  image: string
}

type BannerProps = {
  banner: Banner
  link?: string
}

export const Banner = ({ banner, link }: BannerProps) => (
  <a href={link} target="_blank" rel="noopener">
    <Block
      display={"block"}
      position={"relative"}
      paddingTop={["56.25%", "56.25%", "37.5%", "37.5%"]}
      width={["150%", "150%", "100%", "100%"]}
      height={"0px"}
    >
      <Block
        as={"img"}
        position={"absolute"}
        top={0}
        left={["-16.67%", "-16.67%", 0, 0]}
        width={"100%"}
        height={"100%"}
        src={banner.image}
      />
    </Block>
  </a>
)

const HighlightBanner = ({ banners }: HighlightBannerProps) => {
  const [activeIndex, setActiveIndex] = React.useState(0)
  const onSliderChange = (newIndex: number) => {
    setActiveIndex(newIndex)
  }
  const settings = {
    dots: true,
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 800,
    arrows: false,
    autoplaySpeed: 8000,
    pauseOnHover: true,
    cssEase: "linear",
    afterChange: onSliderChange,
    className: "highlight-banner",
  }
  return (
    <Block maxWidth={"1920px"} margin={"auto"}>
      <Slider {...settings}>
        {banners.map((banner, index) => (
          <Banner
            key={index}
            banner={banner}
            link={banners[activeIndex].link}
          />
        ))}
      </Slider>
    </Block>
  )
}

export default HighlightBanner
